export function groupArrayBy(objectArray: any, property: string): any {
  return objectArray.reduce(function (accumulator: any, currentObject: any) {
    const key = currentObject[property];
    if (!accumulator[key]) {
      accumulator[key] = [];
    }
    accumulator[key].push(currentObject);
    return accumulator;
  }, {});
}
